<template>
  <!-- Use standard modal structure -->
  <div v-if="show_waiting" v-legacy-overlay data-usage-dialog="chart" class="modal-overlay legacy-ticker-dialog" @click="_closeWindow">
    <div class="modal-container add-waiting-modal" role="dialog" aria-modal="true" aria-label="Añadir ticker a cartera" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="title-wrapper">
            <span class="material-icons-outlined header-icon">playlist_add</span>
            <h3 class="modal-title">Añadir ticker a cartera</h3>
        </div>
        <button class="modal-close-btn" type="button" aria-label="Cerrar añadir ticker a cartera" @click="_closeWindow">
            <i class="material-icons">close</i>
        </button>
                </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="ticker-info">
          <span class="ticker-label">Ticker:</span>
          <span class="ticker-name">{{ stock.ticker }}</span>
                </div>

        <!-- Portfolio Selection -->
        <div class="form-group cartera-select" v-if="user_portfolios.length > 0 && portfolio_selected.length > 0">
          <label class="input-label" for="add-waiting-cartera-element">Cartera</label>
          <select id="add-waiting-cartera-element" class="vanilla-select" v-model="portfolio">
            <option disabled value="">-- Seleccione --</option> 
            <option v-for="p in user_portfolios" :key="p.value" :value="p.value">
              {{ p.name }}
            </option>
          </select>
                </div>
        <div v-else class="info-message">Cargando carteras...</div>

        <!-- Instrument Type Selection -->
        <div class="form-group cartera-select">
          <label class="input-label" for="cartera-element">Tipo de instrumento</label>
          <select id="cartera-element" class="vanilla-select" v-model="instrument">
            <option v-for="type in instrument_type_options" :key="type.value" :value="type.value">
               {{ type.name }}
            </option>
          </select>
        </div>

        <div v-if="_requiresManualPayload && _hasManualFieldsToShow" class="manual-fields">
          <div v-if="form_error" class="error-message">{{ form_error }}</div>
          <div v-if="_shouldShowManualField('currency')" class="form-group">
            <label class="input-label" for="waiting-currency">Divisa</label>
            <select class="vanilla-input" id="waiting-currency" v-model="manual_form.currency">
              <option disabled value="">Selecciona una divisa</option>
              <option v-for="currency in currency_options" :key="currency.value" :value="currency.value">
                {{ currency.label }}
              </option>
            </select>
          </div>
          <div v-if="_shouldShowManualField('in_price')" class="form-group">
            <label class="input-label" for="waiting-in_price">Precio de entrada</label>
            <input class="vanilla-input" type="text" id="waiting-in_price" v-model.trim="manual_form.in_price" placeholder="0.00" />
          </div>
          <div v-if="_shouldShowManualField('support_price')" class="form-group">
            <label class="input-label" for="waiting-support_price">Precio de soporte</label>
            <input class="vanilla-input" type="text" id="waiting-support_price" v-model.trim="manual_form.support_price" placeholder="0.00" />
          </div>
          <div v-if="_isCfdInstrument && _shouldShowManualField('cfd_margin')" class="form-group">
            <label class="input-label" for="waiting-cfd_margin">Margen CFD</label>
            <input class="vanilla-input" type="text" id="waiting-cfd_margin" v-model.trim="manual_form.cfd_margin" placeholder="0.00" />
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
         <button class="action-btn secondary-btn" @click="_closeWindow">Cancelar</button>
         <button 
            class="action-btn primary-btn"
            @click="_sendAction" 
            :disabled="!_canSubmit">
            {{ _addButtonText }}
         </button>
        </div>
    </div>
</div>
</template>

<script>
import "vue-swatches/dist/vue-swatches.css";
import APICaller from "@/shared/mixins/APICaller.js";
import inputFavorites from './configs/favorites-workspace.json';
import inputEditFavorites from './configs/edit-favorites-workspace.json';
import { mapGetters } from "vuex";
import legacyOverlay from '../directives/legacyOverlay';
import SelectWallet from "@/features/stockchart/components/configs/select_waiting.json";
import SelectType from "@/features/stockchart/components/configs/select_type_instrument.json";

export default {
    directives: { legacyOverlay },
    mixins: [APICaller],
    name: 'WaitingValuesAdd',
    props: {
        stock: { type: Object, default: () => ({}) },
        show_waiting: { type: Boolean},
    },

    data: () => ({
        input_favorites : inputFavorites,
        input_edit_favorites : inputEditFavorites,
        workspaces: [],
        isClosingShieldOn: false,
        isCreating: false,
        isDeleting: false,
        isEditing: false,
        createWorkspaceNewName: "",
        editWorkspaceNewName: "",
        currentlyDeleting: {},
        currentlyEditing: {},
        createWorkspaceColor: "#000000",
        editWorkspaceColor: "#000000",

        user_portfolios:[],
        select_items: SelectWallet,
        portfolio_selected:[],
        helper_text_select:"",

        instrument_type_options: [ 
          { name: 'Stock', value: 'STOCK' },
          { name: 'CFD', value: 'CFD' } 
        ],
        currency_options: [
          { value: 'EUR', label: 'EUR - Euro' },
          { value: 'USD', label: 'USD - Dólar estadounidense' },
          { value: 'GBP', label: 'GBP - Libra esterlina' },
          { value: 'JPY', label: 'JPY - Yen japonés' },
          { value: 'CHF', label: 'CHF - Franco suizo' },
          { value: 'CAD', label: 'CAD - Dólar canadiense' },
          { value: 'AUD', label: 'AUD - Dólar australiano' },
        ],
        select_type: SelectType,

        portfolio: '',
        instrument: 'STOCK',
        manual_data_required: false,
        manual_form: {
            currency: '',
            in_price: '',
            support_price: '',
            support_date: '',
            cfd_margin: '',
        },
        manual_fields_to_show: [],
        form_error: '',

        initialized: false,

    }),

    watch: {
        show_waiting: { immediate: true, handler(newValue) {
            if (newValue && !this.initialized) {
                this._initializeData();
            }
            if (newValue && this.initialized) {
                 this._updateSelectionsBasedOnStock();
            }
        } },
        stock: {
            handler(newStock) {
                if (this.show_waiting && this.initialized) {
                   this._updateSelectionsBasedOnStock(newStock);
                }
            },
            deep: true
        },
        instrument() {
            if (this._requiresManualPayload) {
                this._addManualFieldsToShow(this._missingManualFields());
            }
        },
    },

    computed: {
        _requiresManualPayload() {
            return this.manual_data_required || this._stockRequiresManualFields(this.stock);
        },
        _hasMissingManualFields() {
            return this._missingManualFields().length > 0;
        },
        _hasManualFieldsToShow() {
            return this.manual_fields_to_show.length > 0;
        },
        _isCfdInstrument() {
            return String(this.instrument).toUpperCase() === 'CFD';
        },
        _canSubmit() {
            return !!this.portfolio && !!this.instrument && !!this.stock.ticker && (!this._requiresManualPayload || !this._hasMissingManualFields);
        },
        _addButtonText() {
            return 'Añadir a Cartera';
        },
    },

    created() {
    },

    mounted() {
    },

    methods: {
        _initializeData: function() {
            if (!this.stock || Object.keys(this.stock).length === 0) return; 
            this._resetManualForm();
            this._initializeManualForm();
            this._setManualFieldsToShowFromMissing();
            this._getPortfolios(); 
                this.initialized = true;
        },
        
        _updateSelectionsBasedOnStock: function() {
             if (this.portfolio_selected.length > 0) {
                 this.portfolio = this.portfolio_selected[0].name;
             }
             this.instrument = this.instrument || this.instrument_type_options[0].value;
             this.manual_data_required = false;
             this.form_error = '';
             this._resetManualForm();
             this._initializeManualForm();
             this._setManualFieldsToShowFromMissing();
        },
        
        _getPortfolios: function() {
            let success = (response) => {                
                this.user_portfolios = response.data.map(p => ({ name: p.name, value: p.idc }));
                this._defaultPortfolio();
            };
            let url = '/api/v1/portfolio/list';
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('092', 'Error cargando lista de carteras.');
            this._getAPICall(url, successHandler, failureHandler);
        },

        _defaultPortfolio: function(){
             if (this.user_portfolios.length > 0) {
                 let defaultP = this.user_portfolios[0]; 
                 this.portfolio_selected = [{ name: defaultP.value, value: defaultP.name }];
                 this.portfolio = defaultP.value;
             } else {
                 console.warn("Default portfolio called before portfolios loaded.");
             }
        },

        _sendAction: function(){
            this.form_error = '';

            if (!this.portfolio || !this.instrument || !this.stock.ticker) return;

            if (this._requiresManualPayload) {
                this._sendManualWaitingAction();
                return;
            }

            let params = new URLSearchParams();
            params.append('instrument_type', this.instrument);
            params.append('ticker', this.stock.ticker);
            if (!this._isEmpty(this.stock.tipus_entrada)) params.append('entry_type', this.stock.tipus_entrada);
            if (!this._isEmpty(this.stock.direccio)) params.append('direction', this.stock.direccio);

            let url = '/api/v1/portfolio/waitings/add/' + this.portfolio;

            let success = (response) => {
                if (response.data && response.data.status === 'requires_manual_data') {
                    this.manual_data_required = true;
                    this._initializeManualForm();
                    this._setManualFieldsToShowFromMissing();
                    this._sendManualWaitingAction();
                    return;
                }

                this.$vueOnToast.pop('success', "Ticker " + this.stock.ticker, "Enviado a cartera!");
                this.$emit("waiting-added");
                this._closeWindow();
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('279', 'Error agregando ticker a la cartera.');
            this._postAPICall(url, params, successHandler, failureHandler);
        },

        _sendManualWaitingAction: function() {
            this._initializeManualForm();
            const missingFields = this._missingManualFields();
            if (missingFields.length > 0) {
                this._addManualFieldsToShow(missingFields);
                this.form_error = 'Completa los datos necesarios para añadir este valor.';
                return;
            }

            let params = this._buildManualWaitingPayload();
            let url = '/api/v1/portfolio/waitings/add/' + this.portfolio;

            let success = (response) => {
                if (response.data && response.data.status === 'requires_manual_data') {
                    this._addManualFieldsToShow(response.data.required_fields || this._missingManualFields());
                    this.form_error = 'Completa los datos necesarios para añadir este valor.';
                    return;
                }
                if (response.data && response.data.status && response.data.status !== 'ok') {
                    this.$vueOnToast.pop('error', "Ticker " + this.stock.ticker, "No se ha podido añadir a cartera.");
                    return;
                }

                this.$vueOnToast.pop('success', "Ticker " + this.stock.ticker, "Enviado a cartera!");
                this.$emit("waiting-added");
                this._closeWindow();
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('280', 'Error agregando ticker a la cartera.');
            this._postAPICall(url, params, successHandler, failureHandler);
        },

        _buildManualWaitingPayload: function() {
            const params = new URLSearchParams();
            params.append('instrument_type', this.instrument);
            params.append('ticker', this.stock.ticker);
            params.append('entry_type', this._stockValue(this.stock, ['tipus_entrada', 'entry_type']) || 0);
            params.append('direction', this._stockValue(this.stock, ['direccio', 'direction']) || 1);
            params.append('currency', this._manualValue('currency'));
            params.append('in_price', this._manualValue('in_price'));
            params.append('support_price', this._manualValue('support_price'));
            params.append('support_date', this._manualValue('support_date') || this._defaultSupportDate());
            params.append('is_ipo', this._stockValue(this.stock, ['is_ipo', 'ipo']) || 0);
            if (this._isCfdInstrument) {
                params.append('cfd_margin', this._manualValue('cfd_margin'));
            }
            return params;
        },

        _initializeManualForm: function() {
            this.manual_form.currency = this.manual_form.currency || this._normalizeCurrency(this._stockValue(this.stock, ['divisa', 'currency']));
            this.manual_form.in_price = this.manual_form.in_price || this._stockValue(this.stock, ['in_price', 'real_entry', 'entry_price', 'entrada']);
            this.manual_form.support_price = this.manual_form.support_price || this._stockValue(this.stock, ['support_price', 'soport', 'support', 'out_price']);
            this.manual_form.support_date = this.manual_form.support_date || this._dateForInput(this._stockValue(this.stock, ['support_date', 'data_soport', 'fecha_soporte']));
            this.manual_form.cfd_margin = this.manual_form.cfd_margin || this._stockValue(this.stock, ['cfd_margin']);
        },

        _resetManualForm: function() {
            this.manual_form = {
                currency: '',
                in_price: '',
                support_price: '',
                support_date: '',
                cfd_margin: '',
            };
            this.manual_fields_to_show = [];
        },

        _setManualFieldsToShowFromMissing: function() {
            this.manual_fields_to_show = this._missingManualFields();
        },

        _addManualFieldsToShow: function(fields) {
            const userEditableFields = fields.filter(field => field !== 'support_date');
            this.manual_fields_to_show = Array.from(new Set(this.manual_fields_to_show.concat(userEditableFields)));
        },

        _missingManualFields: function() {
            const fields = ['currency', 'in_price', 'support_price'];
            if (this._isCfdInstrument) fields.push('cfd_margin');
            return fields.filter(field => this._manualFieldIsMissing(field));
        },

        _shouldShowManualField: function(field) {
            return this.manual_fields_to_show.includes(field);
        },

        _manualFieldIsMissing: function(field) {
            const value = this._manualValue(field);
            if (this._isEmpty(value)) return true;
            if (field === 'currency') return !/^[A-Z]{3,6}$/.test(value);
            if (field === 'support_date') return !/^\d{4}-\d{2}-\d{2}$/.test(value);
            return !this._isValidNumber(value);
        },

        _isValidNumber: function(value) {
            const normalized = String(value).replace(',', '.');
            return normalized !== '' && !isNaN(parseFloat(normalized)) && isFinite(normalized);
        },

        _manualValue: function(field) {
            if (field === 'currency') {
                return this._normalizeCurrency(this.manual_form.currency);
            }
            if (['in_price', 'support_price', 'cfd_margin'].includes(field)) {
                return String(this.manual_form[field]).replace(',', '.');
            }
            return this.manual_form[field];
        },

        _stockRequiresManualFields: function(stock = this.stock) {
            return this._isEmpty(this._stockValue(stock, ['tipus_entrada', 'entry_type'])) || this._isEmpty(this._stockValue(stock, ['direccio', 'direction']));
        },

        _stockValue: function(stock, fields) {
            if (!stock) return '';

            for (let index = 0; index < fields.length; index++) {
                let value = stock[fields[index]];

                if (!this._isEmpty(value)) {
                    return value;
                }
            }

            return '';
        },

        _isEmpty: function(value) {
            return value === undefined || value === null || value === '';
        },

        _normalizeCurrency: function(currency) {
            currency = currency ? String(currency).toUpperCase() : '';

            if (currency.length === 6) {
                return currency.substring(3, 6);
            }

            return currency;
        },

        _dateForInput: function(date) {
            if (this._isEmpty(date)) return '';
            date = String(date).trim();
            if (date === '01/01/1970' || date === '01-01-1970' || date === '1970-01-01') return '';
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
                const parts = date.split('/');
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
                const parts = date.split('-');
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return '';
        },

        _defaultSupportDate: function() {
            const date = new Date();
            const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            return localDate.toISOString().slice(0, 10);
        },

        _closeWindow: function() {
             this.$emit('_closeWaitingValueWindow');
        },

        _generateRandomHexColor: function() {
            let randomColor = Math.floor(Math.random()*16777215).toString(16);
            return "#" + randomColor;
        },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/legacy-ticker-dialogs.scss";
</style>
